export enum Ubicacion {
  Encabezado = 'ENCABEZADO',
  Cuerpo = 'CUERPO',
  Pie = 'PIE'
}
